import { render } from "./AdministratorListCourseContent.vue?vue&type=template&id=ceca5b76&scoped=true"
import script from "./AdministratorListCourseContent.vue?vue&type=script&lang=js"
export * from "./AdministratorListCourseContent.vue?vue&type=script&lang=js"

import "./AdministratorListCourseContent.vue?vue&type=style&index=0&id=ceca5b76&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceca5b76"]])

export default __exports__